<div class="input-group inner-addon right-addon">
    <input
        #searchInput
        class="form-control"
        type="text"
        [formControl]="formControl"
        [autocomplete]="autoComplete"
        [placeholder]="placeholder"
        [class.is-invalid]="ngControl.invalid && ngControl.touched"
        (blur)="onTouch?.()"
        name="search"
        #input />
    <i class="bi bi-search" width="32" height="32"></i>
</div>
